export default {
      id: "done-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#done-usage",
      toString: function () {
        return this.url;
      }
    }